:host {
  box-sizing: border-box;
  width: 100%;
  display: block;
  padding: 2rem 1rem;
  height: auto;
  margin-bottom: var(--cms-components-mb);
  background: #666;
  background: linear-gradient(
    135deg,
    #666 74%,
    #fa9d26 74%,
    #fa9d26 93%,
    #666 93%,
    #666 94%
  );
  filter: progid:dximagetransform.microsoft.gradient(startColorstr='#666666', endColorstr='#666666', GradientType=1);

  @include cms-base-font;
}

:host * {
  box-sizing: border-box;
}

.store-module-headline-wrapper {
  @include override-css-var(
    theme-text-color,
    css-var(semanticColors-base-inverted-strong-text)
  );
}

.label {
  @include label-base-font;
}

.market-image {
  height: 100% !important;
  object-fit: cover;
}

.market-address-wrapper,
.open-times-wrapper {
  padding-left: 1rem;
  width: 100%;
}

.address-icon-wrapper {
  display: flex;
  width: 30px;
  justify-content: center;
}

.svg-locator {
  height: 24px;
}

.store-info-button {
  width: 100%;
  margin-top: 1rem;
}
.search-store-button {
  width: 100%;
}
.market-info-link {
  --cms-theme-text-color: css-var(semanticColors-base-strong-text);
  margin-left: 8px;
  @include cms-anchor-base-font;
}

.market-open-times {
  margin-bottom: 0.75rem;
}

.open-times-label {
  margin-bottom: 0.5rem;
}

.search-label {
  display: flex;
  align-items: center;
  margin-bottom: var(--cms-spacing-100);
}

.svg-store {
  margin-right: 0.75rem;
}

.market-contact,
.market-map,
.market-phone {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.store-module-inner {
  max-width: css-var(container-max-width);
  margin-left: auto;
  margin-right: auto;
}

.store-module-content {
  display: grid;
  gap: 0.75rem;
  grid-template-rows: repeat(auto-fill, 1fr);
  grid-template-columns: repeat(css-var(css-grid-size), 1fr);
}

.grid-item {
  grid-area: auto / auto / auto / span 12;
}

.store-open-time,
.open-date {
  display: flex;
}

.open-day {
  flex: 0 0 35%;
  max-width: 35%;
}

.special-date {
  flex: 0 0 35%;
  max-width: 35%;
}

.market-info-wrapper {
  height: 100%;
  min-height: 300px;
  background: css-var(semanticColors-container-weak-background);
  display: flex;
  flex-flow: wrap row;
  padding-top: 1rem;
  color: css-var(semanticColors-base-strong-text);
}

.flex-item {
  flex: 0 0 100%;
  max-width: 100%;
  margin-bottom: 1rem;
  padding: 0 1rem;
}

.flex-item:last-child {
  margin-bottom: 0;
  padding-top: 1rem;
  padding-bottom: 1rem;
  background: css-var(semanticColors-base-medium-background);
}

.address-content,
.open-times-content {
  display: flex;
}

.icon-wrapper {
  flex: 0 0 20px;
  max-width: 20px;
}

@include media-width($breakpoint-sm) {
  .flex-item:is(:not(:last-child)) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .market-info-button-wrapper {
    max-width: 66.66%;
    margin-left: auto;
    margin-right: auto;
  }
}

@include media-width($breakpoint-md) {
  .grid-item:first-child {
    grid-area: auto / auto / auto / span 8;
  }

  .grid-item:last-child {
    grid-area: auto / auto / auto / span 4;
  }

  .flex-item {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
